import React from 'react';
import CrmCommunicationTicketsList, {
  CRM_COMM_MASK_COMPLETE_LIST,
  CRM_COMM_PAGE_COMPLETE_LIST,
} from './CrmCommunicationTicketsList';

/** Úplný zoznam – maska cust021, vlastná user/standard maska (R6). */
export default function CrmCommunicationCompleteList(props) {
  return (
    <CrmCommunicationTicketsList
      {...props}
      mineOnlyDefault={false}
      crmTicketsLayout
      listPageKey={CRM_COMM_PAGE_COMPLETE_LIST}
      maskCode={CRM_COMM_MASK_COMPLETE_LIST}
    />
  );
}
